<script>

  import store from '~/Library/store'
  import { fly } from 'svelte/transition'
  import { createOfferSignup } from '~/Library/api'
  import { getCookie, setCookie } from '~/Library/cookies'

  export let card = {}

  const isVimeoLink = card.offerLink.includes('vimeo')

  let copied = false 
  let prevIndex = -1

  const graphQlType = {
    personal: 'ForYou', 
    career: 'ForYouCareer'
  }[$store.card_type]

  $:if(prevIndex !== $store.card_index){
    prevIndex = $store.card_index
    copied = false 
  } 

  function copy(){
    const el = document.createElement('textarea')
    el.value = 'planb'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    copied = true 
  }

  function trackOfferSignup(){

    const cookieName = `__next4me_click_${graphQlType}${card.id}`

    if ( !getCookie(cookieName)){

      createOfferSignup(`{
        user: { connect: { id: ${$store.user.id} } }
        offer${graphQlType}: {
          connect: {
            id: ${card.id}
          }
        },
        kind: "${graphQlType}",
        title: "${card.title}"
      }`)
        .then((rsp) => true)
        .catch((err) => false)

      setCookie(cookieName, 1, (60 * 60 * 24 * 365))

    }
  }

  function openVideo(){
    trackOfferSignup()
    store.setAttribute('video_source', card.offerLink)
    store.setAttribute('show_video', true)
  }

</script>

<div class="offer" on:click|stopPropagation>

  {#if card.image}

    <div class="offer__image">

      <img src={card.image.publicUrlTransformed} alt="">

    </div>

  {/if}

  <div class="offer__content">

    <h2 class="heading">{card.title}</h2>

    <p>{card.description}</p>

    {#if !isVimeoLink && card.offerCode}

    <small>Your code</small>

    {/if}

    <div class="offer__cta">

      {#if !isVimeoLink && card.offerCode}

        <div class="offer__cta-code">

          <span>{card.offerCode}</span>

          {#if copied}

            <button in:fly="{{ y: -50, duration: 500 }}" class="accent">Copied!</button>

          {:else}

            <button in:fly="{{ y: -50, duration: 500 }}" on:click={copy}>Copy Code</button>

          {/if}

        </div>

      {/if}

      {#if isVimeoLink}

        <button class="offer__cta-redeem" on:click|stopPropagation={openVideo}>Redeem Offer</button>

      {:else}

        <a class="offer__cta-redeem" href={card.offerLink} target="_blank" on:click|stopPropagation={trackOfferSignup}>Redeem Offer</a>

      {/if}

    </div>

  </div>
  
</div>

<style lang="scss">
  :global(.offer) {
    display: flex;
    &__content {
      padding: 4rem 4rem 4rem 2rem;
      flex-basis: 60%;
      :global(p) {
        margin-bottom: 1.5rem;
        line-height: 150%;
        font-size: 0.875rem;
        font-weight: 300;
      }
      h2 {
        margin-bottom: 1.5rem;
      }
    }
    &__image {
      padding: 4rem 2rem 4rem 4rem;
      padding-right: 2rem;
      flex-basis: 40%;
      height: auto;
      flex-shrink: 0;
      max-width: 18rem;
      img {
        width: 100%;
        height: auto;
      }
    }
    &__cta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-redeem {
        background-color: var(--accent-colour);
        border-radius: 2rem;
        color: white;
        border: none;
        font-size: 1.25rem;
        padding: 1.125rem 2rem;
        margin: 1rem 1rem 0 1rem;
        text-align: center;
      }
    }
    &__cta-code {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem;
      background-color: white;
      box-shadow: 0px 10px 40px rgba(21, 53, 43, 0.09);
      border-radius: 0.625rem;
      margin-top: 1rem;
      span {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 1.125rem;
        padding-left: 1.25rem;
      }
      small {
        display: block;
        margin: 0.325rem 1.85rem;
        color: var(--accent-colour);
      }
      button {
        height: 100%;
        width: 6rem;
        color: white;
        background-color: var(--dark-button);
        border: none;
        border-radius: 0.5rem;
        margin-left: 1.75rem;
        padding: 0.5rem;
        cursor: pointer;
        &.accent {
          background-color: transparent;
          color: var(--accent-colour);
          font-weight: bold;
        }
      }
    }
    @media only screen and (max-width: 576px) {
      flex-direction: column;
      max-width: 100%;
      overflow: scroll;
      &__cta {
        align-items: flex-start;
        flex-direction: column;
        button {
          width: 100%; 
        }
      }
      &__image {
        padding: 1.5rem;
        flex-basis: unset;
        img {
          height: 9.75rem;
        }
      }
      &__content {
        padding: 1.5rem;
        margin-top: 1.5rem;
      }
    }
  }; 
</style>
